export function mapMultiSalesforceToSingle(questions) {
  let result = [];
  questions.forEach((q) => {
    q.options.forEach((o) => {
      const valueMarked = q.answer.includes(o.value);
      if (o.salesforceId) {
        result.push({
          flag: o.salesforceId,
          answer: answerToString(valueMarked, o.invertSelection),
          salesforceId: o.salesforceId,
        });
      }
    });
  });

  return result;
}

function answerToString(valueMarked, invertSelection) {
  if (invertSelection) {
    return valueMarked ? "No" : "Yes";
  }
  return valueMarked ? "Yes" : "No";
}